import { AutoComplete, Button, Col, Collapse, DatePicker, Row, Select, Spin, Switch, Radio, Space, Card, Form, Checkbox } from "antd";
import jwt_decode from "jwt-decode";
import React, { useEffect, useRef, useState } from "react";
import { generateBlob } from "../../Utils/CreateBlob";
import { generateCustomerDetailsExcel } from "../../Utils/CustomerDetailsExcel";
import { disabledDate } from "../../Utils/Util";
import { errHandler } from "../../helper/helper";
import CustomerDetailsReport from "./CustomerDetailsReport";
import './General.css';
import {
    generateDistrictWiseCountReport,
    generateIncomeReportBranchSummary,
    generateOtherBankBranchWise,
    generateSamurthiBankDetailsReport,
    generateSocialBenefitAccountReportDistrictVise,
    generateSocialBenefitReport,
    generateStatementReportBranchSummary,
    generatebalanceCheckDeposit,
    generatebalanceCheckLoan,
    generateinvestmentSummaryReportDistrictWise,
    generateinvestmentSummaryReportIslandWise,
    getAllBranches,
    getAllDistrict,
    getBsReportDetails,
    getDailyWorkDetails,
    getReportDetails,
    getAllBranchesByDistrictName,
    getDivAreaBranches,
    getBranchesByDivArea,
    generateIncomeStatementReportDistrictSummary,
    getAllUsersByBranch,
    getAllDailyTransactions,
    getAllDistributionNameByBranch,
    getAllDistributionList,
    generateInvestmentReviewReport,
    generateInvestmentTrailBalance,
    pnlNotesReport,
    bsNotesReport,
    dailyWorkDetailsReport,
    customerDetailsReportExcel,
    customerDetailsReportPdf,
    getAllDepositsProducts,
    getAllLoansProducts,
    getAllWasams,
    getAllBranchByDistrictId,
    getAllDistrictList,
    getAllWasmaByBranchIds,
    searchCustomerNames,
    getDistrictDivisionalBranchDetails
} from "./GeneralService";

import { useNavigate } from "react-router-dom";
import CustomFooter from "../../Layout/CustomFooter";
import DistrictBsNodesReport from "./DistrictBsNodesReport";
import DistrictPnlNodesReport from "./DistrictPnlNodesReport";
import CommonDistribution from "./CommonDistribution";
import PermissionPanel from "../../Layout/PermissionPanel";
import BranchWiseInvestmentSummary from './BranchWiseInvestmentSummary';
import BranchLocationSelector from "../BranchLocationSelector";
import InvestmentReviewReport from "./InvestmentReviewReport";

import ProsperityReport from "./ProsperityReport";
const { Panel } = Collapse;

const createdData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            id: post.id,
            branchCode: post.branchCode,
            branchName: post.branchName,
            branchNumber: post.branchNumber,
            locked: post.locked,
            divisionalAreaId: post.divisionaAreaId,
        }

    }))
    return convertedData;
};

const createDistrictData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            districtId: post.districtId,
            districtName: post.districtName,
            districtCode: post.districtCode,
            provinceId: post.provinceId,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }

    }))
    return convertedData;
};

const createDistributionData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            id: post.id,
            listName: post.listName,
        }

    }))
    return convertedData;
};


const createReportData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            rptId: post.rptId,
            reportName: post.reportName,
            rptStatus: post.rptStatus
        }
    }))
    return convertedData;
};

const createDailyWorkData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            ledgerCode: post.ledgerCode,
            cashCredit: post.cashCredit,
            cashDebit: post.cashDebit,
            nonCashDebit: post.nonCashDebit,
            nonCashCredit: post.nonCashCredit,
        }
    }))
    return convertedData;
};

const createDailyTransaction = (rawData) => {
    const formattedData = {
        CD: [],
        CW: [],
        ACD: [],
        ACW: [],
        LP: [],
        PD: [],
        nonCashDepositList: [],
        nonCashLedgerList: [],
        nonCashWithdrawList: [],
        voucherCredit: [],
        voucherDebit: [],
        selectedDate: rawData.date

        // Add other categories as needed
    };

    if (rawData.CD && rawData.CD.length > 0) {
        formattedData.CD = rawData.CD.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }

    if (rawData.CW && rawData.CW.length > 0) {
        formattedData.CW = rawData.CW.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.ACD && rawData.ACD.length > 0) {
        formattedData.ACD = rawData.ACD.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.ACW && rawData.ACW.length > 0) {
        formattedData.ACW = rawData.ACW.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.LP && rawData.LP.length > 0) {
        formattedData.LP = rawData.LP.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.PD && rawData.PD.length > 0) {
        formattedData.PD = rawData.PD.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.nonCashDepositList && rawData.nonCashDepositList.length > 0) {
        formattedData.nonCashDepositList = rawData.nonCashDepositList.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.nonCashLedgerList && rawData.nonCashLedgerList.length > 0) {
        formattedData.nonCashLedgerList = rawData.nonCashLedgerList.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.nonCashWithdrawList && rawData.nonCashWithdrawList.length > 0) {
        formattedData.nonCashWithdrawList = rawData.nonCashWithdrawList.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.settleList && rawData.settleList.length > 0) {
        formattedData.settleList = rawData.settleList.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.voucherCredit && rawData.voucherCredit.length > 0) {
        formattedData.voucherCredit = rawData.voucherCredit.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    if (rawData.voucherDebit && rawData.voucherDebit.length > 0) {
        formattedData.voucherDebit = rawData.voucherDebit.map((transaction, index) => ({
            id: index + 1,
            valueDate: transaction.valueDate,
            transactionType: transaction.transactionType,
            transactionNumber: transaction.transactionNumber,
            accountNumber: transaction.accountNumber,
            amount: transaction.amount,
            memo: transaction.memo,
            user: transaction.user
        }));
    }
    return formattedData;
};


const createDepositsProductData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            productId: post.productId,
            productCode: post.productCode,
            productName: post.productName
        }
    }))
    return convertedData;
};

const createLoansProductData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            productId: post.productId,
            productCode: post.productCode,
            productName: post.productName
        }
    }))
    return convertedData;
};

const createWasamsData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            wastId: post.wastId,
            wasName: post.wasName,
            wasCode: post.wasCode,
        }
    }))
    return convertedData;
}

const createBranchData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            id: post.id,
            branchName: post.branchName,
            branchCode: post.branchCode,
        }
    }))
    return convertedData;
}

const createDistrictsData = (data) => {
    let convertedData = (data.map((post) => {
        return {
            districtId: post.districtId,
            districtCode: post.districtCode,
            districtName: post.districtName
        }
    }))
    return convertedData;
}


// export default createDailyTransaction;

const createDivAreaData = (data) => {
    return (data.map((post) => {
        return {
            divAId: post.divAId,
            divAIdCode: post.divAIdCode,
            divAIdName: post.divAIdName,
            districtId: post.districtId,
            branchDtoList: post.branchDtoList.map(e => {
                return {
                    id: e.id,
                    branchCode: e.branchCode,
                    branchName: e.branchName
                }
            })
        }
    }));
};

const General = () => {
    const [data, setData] = useState([]);
    const [date, setDate] = useState([]);
    const [branchData, setBranchData] = useState([]);
    //
    const [branchesForSelectedDistrict, setBranchesForSelectedDistrict] = useState([])
    //

    const [depositsProducts, setDepositsProducts] = useState(null);
    const [loanProducts, setLoanProducts] = useState(null);
    const [wasams, setWasams] = useState(null);
    const [branches, setBranches] = useState(null);
    const [districts, setDistricts] = useState(null);

    const [loanLoading, setLoanLoading] = useState(false);
    const [districtLoading, setDistrictLoading] = useState(false);
    const [districtDepositLoading, setDistrictDepositLoading] = useState(false);
    const [districtData, setDistrictData] = useState([]);
    const [investDistrictLoading, setInvestDistrictLoading] = useState(false);
    const [investDistrictDate, setInvestDistrictDate] = useState(null);
    const [innvestTimePeriod, setInnvestTimePeriod] = useState(null);
    const [isExcelSavingsAndLoans, setIsExcelSavingsAndLoans] = useState(false)
    const [isExcelInvestmentSummary, setIsExcelInvestmentSummary] = useState(false);
    const [isExcelGenderWiseCustomer, setIsExcelGenderWiseCustomer] = useState(false);
    const [isExcelSocialBenefitAccount, setIsExcelSocialBenefitAccount] = useState(false);
    const [isExcelBalanceCheckCertificate, setIsExcelBalanceCheckCertificate] = useState(false);
    const [isExcelIncomeReportSummury, setIsExcelIncomeReportSummury] = useState(false);
    const [samurdhiBankDetailsLoading, setSamurdhiBankDetailsLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [otherBankDate, setOtherBankDate] = useState(null);
    const [reportData, setReportData] = useState([]);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedDistrictBalanceCheck, setSelectedDistrictBalanceCheck] = useState(null);
    const [selectedBranch, setSelectedBranch] = useState(null);

    //daily
    const [selectedTransaction, setSelectedTransaction] = useState([]);
    const [selectedUser, setSelectedUser] = useState(null);
    const [selectedDistributionId, setSelectedDistributionId] = useState(null);
    const [userData, setUserData] = useState([]);
    const [distributionData, setDistributionData] = useState([]);



    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedBsDates, setSelectedBsDates] = useState(null);
    const [selectedReport, setSelectedReport] = useState(null);
    const [depositBalanceLoding, setDepositBalanceLoading] = useState(false);
    const [loanBalanceLoading, setLoanBalanceLoading] = useState(false);
    const [bsReportData, setBsReportData] = useState([]);
    const [selectedBsReport, setSelectedBsReport] = useState(null);
    const [bsReportLoading, setBsReportLoading] = useState(false);
    const [investmentLoading, setInvestmentLoading] = useState(false);
    const [incomeReportLoading, setIncomeReportLoading] = useState(false);
    const [dailyReportLoading, setDailyReportLoading] = useState(false);
    const [dailyTransactionLoading, setDailyTransactionLoading] = useState(false);
    const [distributionListLoading, setDistributionListLoading] = useState(false);
    const [divAreaData, setDivAreaData] = useState([]);
    const [selectedDivisionalArea, setSelectedDivisionalArea] = useState(null);
    const [isExcelBalanceCheckCertificateLoan, setIsExcelBalanceCheckCertificateLoan] = useState(false);
    const [isExcelDistributionList, setIsExcelDistributionList] = useState(false);
    const [districtRadio, setDistrictRadio] = useState(1);
    const [selectedDatesInvestment, setSelectedDatesInvestment] = useState([]);
    const [innvestTimePeriodBranch, setInnvestTimePeriodBranch] = useState(null);
    const [dailyTransactionData, setDailyTransactionData] = useState({});
    const [investReviewLoading, setInvestReviewLoading] = useState(false);
    const [investReviewExcel, setInvestReviewExcel] = useState(false);
    const [branchRadio, setBranchRadio] = useState(0);



    const [selectedDistrictForGenderWiseDetails, setselectedDistrictForGenderWiseDetails] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [isBsChecked, setBsIsChecked] = useState(false);
    const [isPdfFormat, setPdfFormat] = useState(false);

    //for customer-detail-report
    const [selectedCustomerNumbersByNumber, setSelectedCustomerNumbersByNumber] = useState([]);
    const [selectedCustomerNumbersByName, setSelectedCustomerNumbersByName] = useState([]);
    const [selectedCustomerName, setSelectedCustomerName] = useState([]);
    const [selectedCustomerStatus, setSelectedCustomerStatus] = useState(2);
    const [selectedDepositProducts, setSelectedDepositProducts] = useState();
    const [selectedLoanProducts, setSelectedLoanProducts] = useState();
    const [selectedWasams, setSelectedWasams] = useState();
    const [selectedBranches, setSelectedBranches] = useState();
    const [selectedDistricts, setSelectedDistricts] = useState(null);
    const [isExcelCustomerReport, setIsExcelCustomerReport] = useState(true);
    const [customerDetailsLoading, setCustomerDetailsLoading] = useState(false);
    const [customerSearchResults, setCustomerSearchResults] = useState([]);
    const [branchesForDivArea, setBranchesForDivArea] = useState([]);
    const [districtDivisionalBranchData, setDistrictDivisionalBranchData] = useState([]);

    //for customer-registration-report
    const [reportLoading, setReportLoading] = useState(false);
    const [customerRegistrationData, setCustomerRegistrationData] = useState({});

    const [branchWiseInvestmentLoading, setBranchWiseInvestmentLoading] = useState(false);

    const [locationData, setLocationData] = useState({});


    const investmentPeriodOptions = [
        {
            label: 'ALL',
            value: 1,
        },
        {
            label: '7 DAYS',
            value: 7,
        },
        {
            label: '1 MONTH',
            value: 30,
        },
        {
            label: '3 MONTHS',
            value: 90,
        },
        {
            label: '6 MONTHS',
            value: 180,
        },
        {
            label: '12 MONTHS',
            value: 360,
        },
    ];


    const loginPlaceId = localStorage.getItem("placeId");
    const branchId = localStorage.getItem("branchId") ? Number(localStorage.getItem("branchId")) : '';
    const token = localStorage.getItem("accessToken")
    const decodeToken = token ? jwt_decode(token) : null;
    const districtName = loginPlaceId === "4" ? decodeToken.districtName : null;
    const districtId = loginPlaceId === "4" ? decodeToken.districtId : null;
    const divAId = loginPlaceId === "2" ? decodeToken.divAId : null;



    const { Option } = Select;
    const { RangePicker } = DatePicker;


    const navigate = useNavigate();


    const handleBranchesChange = (value) => {
        setSelectedBranches(value);
    };

    const onReportDataUpdate = (data) => {
        setCustomerRegistrationData(data);
    };

    const navigation = (route, params) => {
        // Navigate to the specified route with optional parameters
        navigate(route, params);
    };

    const handleDepositProductChange = (value) => {
        setSelectedDepositProducts(value);
    };

    const handleLoanProductChange = (value) => {
        setSelectedLoanProducts(value);
    };

    const handleWasamChange = (value) => {
        setSelectedWasams(value);
    };

    const handleDistrictsChange = (value) => {
        setSelectedDistricts(value);
    };


    const onRadioChange = (e) => {
        setBranchRadio(e.target.value);
    };

    const handleDateChange = (dates) => {
        setSelectedDates(dates);
    };

    const handleDateChangeInvestment = (dates) => {
        setSelectedDatesInvestment(dates);
    };

    const handleBsDateChange = (dates) => {
        setSelectedBsDates(dates);
    };

    const handleReportChange = (value) => {
        setSelectedReport(value);
    }

    const handleBsReportChange = (value) => {
        setSelectedBsReport(value);
    }


    const handleDistrictSelect = (value) => {
        setSelectedDistrict(value);

        const filtered = districtData.filter((district) =>
            district.districtName.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered)
    };

    const handleDistrictSelectForBalanceCheck = (value) => {
        setSelectedDistrictBalanceCheck(value);

        const filtered = districtData.filter((district) =>
            district.districtName.toLowerCase().includes(value.toLowerCase())
        );
        setFilteredData(filtered)
    }

    const handleDistrictRadioChange = (e) => {
        if (e.target.value === 1) {
            setSelectedDistrictBalanceCheck(null);
        }
        setDistrictRadio(e.target.value);
    };

    const handleDistrictSelectDistrict = (value) => {
        setSelectedDistrictBalanceCheck(value);


    }


    const handleBranchChange = (value) => {

        setSelectedBranch(value);
        if (loginPlaceId === "4") {
            fetchUserDataByBranchId(value);
            fetchDitributionNamesByBranchId(value);
        }


    };
    const handleTransactions = (value) => {


        setSelectedTransaction(value);
    };



    const handleUserChange = (value) => {
        setSelectedUser(value);
    };
    const handleDistributionNameChange = (value) => {
        setSelectedDistributionId(value);
    };


    const handleTimePeriodChange = (value) => {
        setInnvestTimePeriod(value);
    }

    const handleTimePeriodChangeBranch = (value) => {
        setInnvestTimePeriodBranch(value);
    }

    const onSwitchChangeSavingsAndLoans = (checked) => {
        setIsExcelSavingsAndLoans(checked);
    };

    const onSwitchChangeInvestmentSummary = (checked) => {
        setIsExcelInvestmentSummary(checked);
    };

    const onSwitchChangeGenderWiseCustomer = (checked) => {
        setIsExcelGenderWiseCustomer(checked);
    }

    const onSwitchChangeSocialBenefitAccount = (checked) => {
        setIsExcelSocialBenefitAccount(checked);
    }

    const onSwitchBalanceCheckCertificate = (checked) => {
        setIsExcelBalanceCheckCertificate(checked);
    }

    const onSwitchIncomeReportSummury = (checked) => {
        setIsExcelIncomeReportSummury(checked);
    }

    const onSwitchBalanceCheckCertificateLoan = (checked) => {
        setIsExcelBalanceCheckCertificateLoan(checked);
    }
    const onSwitchDistributionList = (checked) => {
        setIsExcelDistributionList(checked);
    }

    const handleDistrictWiseGenderDetails = (value) => {
        setselectedDistrictForGenderWiseDetails(value);
    }

    const onSwitchInvestReview = (value) => {
        setInvestReviewExcel(value);
    }

    const getAllbranches = () => {
        getAllBranches().then((res => {
            let data = createdData(res.data);
            setData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllBranchesbyDistrict = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrictBalanceCheck : decodeToken.districtName;
        getAllBranchesByDistrictName(districtName).then((res => {
            let data = createdData(res.data);
            setBranchData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllDistricts = () => {
        getAllDistrict().then((res => {
            let data = createDistrictData(res.data);
            setDistrictData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const getAllReports = () => {
        getReportDetails().then((res => {
            let data = createReportData(res.data);
            setReportData(data);
        })).catch((err) => {
            errHandler(err);
        })
    };

    const getAllBsReports = () => {
        getBsReportDetails().then((res => {
            let data = createReportData(res.data);
            setBsReportData(data);
        })).catch((err) => {
            errHandler(err);
        })
    };

    const getAllBranchesByDivAId = () => {
        getDivAreaBranches().then((res => {
            let data = createDivAreaData(res.data);
            setDivAreaData(data);
        })).catch((err) => {
            errHandler(err)
        })
    }

    const getBranchesByDivAId = () => {
        if (!divAId) return;

        getBranchesByDivArea(divAId)
            .then(res => {
                const data = res.data?.map(branch => ({
                    id: branch.id,
                    branchCode: branch.branchCode,
                    branchName: branch.branchName
                }));
                setBranchesForDivArea(data)
            })
            .catch(err => {
                errHandler(err);
            });
    };

    const handleCustomerSearch = (value) => {
        if (!value || value.length < 2) {
            setCustomerSearchResults([]);
            return;
        }

        const data = {
            namePart: value,
            wasamIds: selectedWasams || 0,
            branchIds: selectedBranches || [branchId],
            // branchIds: [280],
        };

        searchCustomerNames(data)
            .then((res) => {
                setCustomerSearchResults(
                    res.data.map((item) => ({
                        label: item.fullName,
                        value: item.cusNo,
                        cusNo: item.cusNo,
                    }))
                );
            })
            .catch((err) => {
                console.error("Customer search failed", err);
            });
    };

    const handleCustomerNameChange = (values) => {
        setSelectedCustomerName(values.map(v => v.label));
        setSelectedCustomerNumbersByName(values.map(v => v.key)); // cusNo
    };


    const generateDistrictWiseLoanAndSavingCountReports = () => {
        let data = {
            isExcel: isExcelSavingsAndLoans,
        }
        setDistrictDepositLoading(true);
        generateDistrictWiseCountReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDistrictDepositLoading(false);
        })

    };
    const generateBranchSocialBenefitReports = () => {
        let data = {
            selectedDate: date,
            branchId: branchId,
        }
        setLoanLoading(true);
        generateSocialBenefitReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setLoanLoading(false);
        })

    };
    const generateinvestSummaryReportDistrict = () => {
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            branchId: selectedBranch,
            timePeriod: innvestTimePeriod,
            districtName: decodeToken.districtName
        }
        setInvestDistrictLoading(true);
        generateinvestmentSummaryReportDistrictWise(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setInvestDistrictLoading(false);
        })

    };
    const generateOtherBankReport = () => {

        if (branchRadio === 1) {
            generateOtherReportBranchWise();
        } else {
            generateinvestSummaryReportIsland();
        }

    }
    const generateinvestSummaryReportIsland = () => {
        const [startDate, endDate] = selectedDatesInvestment;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            timePeriod: innvestTimePeriodBranch,
            isExcel: isExcelInvestmentSummary,
            districtId: selectedDistrictBalanceCheck
        }
        setInvestDistrictLoading(true);
        generateinvestmentSummaryReportIslandWise(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setInvestDistrictLoading(false);
        })

    };

    const generateSamurthiBankDetails = () => {
        let data = {
            isExcel: isExcelGenderWiseCustomer,
            districtName: loginPlaceId === "3" ? selectedDistrictForGenderWiseDetails : decodeToken.districtName,
        }
        setSamurdhiBankDetailsLoading(true);
        generateSamurthiBankDetailsReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setSamurdhiBankDetailsLoading(false);
        })

    };

    const getAllDeposits = () => {
        getAllDepositsProducts().then((res) => {
            let data = createDepositsProductData(res.data);
            setDepositsProducts(data);
        }).catch((err) => {
            errHandler(err);
        })
    }

    const getAllLoans = () => {
        getAllLoansProducts().then((res) => {
            let data = createLoansProductData(res.data);
            setLoanProducts(data);
        }).catch((err) => {
            errHandler(err);
        })
    }

    const getWasamList = (branchIds) => {
        getAllWasmaByBranchIds(branchIds)
            .then((res) => {
                let data = createWasamsData(res.data);
                setWasams(data);
            })
            .catch((err) => {
                errHandler(err);
            });
    };



    const getBranchList = (districtId) => {
        const data = { districtId: districtId };
        getAllBranchByDistrictId(data).then((res) => {
            let data = createBranchData(res.data);
            setBranches(data);
        }).catch((err) => {
            errHandler(err);
        });
    };


    const getAllDistrictl = () => {
        getAllDistrictList().then((res) => {
            let data = createDistrictsData(res.data);
            setDistricts(data);
        }).catch((err) => {
            errHandler(err);
        })
    }

    const getdistrictName = () => {
        getAllDistrict().then((res => {
            let data = createDistrictData(res.data);
            setDistrictData(data);
        })).catch((err) => {
            errHandler(err)
        })
    };

    const generateSocialBenefitAccountReportDistrctVise = () => {
        let districtName = loginPlaceId === "3" ? selectedDistrict : decodeToken.districtName;
        let data = {
            // districtName:decodeToken.districtName? decodeToken.districtName:" "
            districtName: districtName,
            selectedDate: investDistrictDate,
            isExcel: isExcelSocialBenefitAccount,

        }
        setInvestDistrictLoading(true);
        generateSocialBenefitAccountReportDistrictVise(data).then((res) => {
            generateBlob(res.data)
        }).catch(err => {
            errHandler(err)
        }).finally(() => {
            setInvestDistrictLoading(false)
        })
    }

    const generateOtherReportBranchWise = () => {
        let selectedBranchId = loginPlaceId === "4" || loginPlaceId === "2" || loginPlaceId === "3" ? selectedBranch : decodeToken.branchId;
        const [startDate, endDate] = selectedDatesInvestment;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            branchId: selectedBranchId,
            timePeriod: innvestTimePeriodBranch,
            isExcel: isExcelInvestmentSummary

        };
        setInvestDistrictLoading(true);
        generateOtherBankBranchWise(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setInvestDistrictLoading(false);
        })
    };

    const generateOtherReviewReportBranchWise = () => {
        let selectedBranchId = loginPlaceId === "4" || loginPlaceId === "2" ? selectedBranch : decodeToken.branchId;
        let data = {
            isExcel: investReviewExcel,
            branchId: selectedBranchId
        };
        setInvestReviewLoading(true);
        generateInvestmentReviewReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setInvestReviewLoading(false);
        })
    };

    const generateInvestmentTrailBalanceBranch = () => {
        let selectedBranchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let data = {
            selectedDate: investDistrictDate,
            isExcel: investReviewExcel,
            branchId: selectedBranchId
        };
        setInvestReviewLoading(true);
        generateInvestmentTrailBalance(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setInvestReviewLoading(false);
        })
    };

    const handleCheckboxChange = (e) => {
        const checked = e.target.checked;
        setIsChecked(checked);
    };

    const handleBsCheckboxChange = (e) => {
        const checked = e.target.checked;
        setBsIsChecked(checked);
    };
    const handleDailyWorkCheckboxChange = (e) => {
        const checked = e.target.checked;
        setPdfFormat(checked);
    };

    const onSubmit = () => {
        if (!isChecked) {
            generateIncomeReportSummary();
        } else {
            generateIncomePnlNotesReportSummary();
        }

    };

    const generateIncomeReportSummary = () => {
        let selectedBranchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            reportId: selectedReport,
            branchId: selectedBranchId
        }
        setIncomeReportLoading(true);
        generateIncomeReportBranchSummary(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setIncomeReportLoading(false);
        })
    };


    const generateIncomePnlNotesReportSummary = () => {
        let selectedBranchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            reportId: selectedReport,
            branchId: selectedBranchId
        }
        setIncomeReportLoading(true);
        pnlNotesReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setIncomeReportLoading(false);
        })
    };
    const generateIncomeReportDistrictSummary = () => {
        const [startDate, endDate] = selectedDates;
        let data = {
            selectedDate: startDate,
            endDate: endDate,
            reportId: selectedReport,
            districtId: decodeToken.districtId,
            branchId: selectedBranch,
            isExcel: isExcelIncomeReportSummury,
        }
        setIncomeReportLoading(true);
        generateIncomeStatementReportDistrictSummary(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setIncomeReportLoading(false);
        })
    };

    const generateBsReport = () => {
        if (!isBsChecked) {
            generateStatementReportSummary();
        } else {
            generateBSFormatStatementReportSummary();
        }

    };
    const generateStatementReportSummary = () => {
        let branchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let branchIdList = [branchId]
        let data = {
            selectedDate: selectedBsDates,
            reportId: selectedBsReport,
            branchIdList: branchIdList
        }
        setBsReportLoading(true);
        generateStatementReportBranchSummary(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setBsReportLoading(false);
        })
    };

    const generateBSFormatStatementReportSummary = () => {
        let branchId = loginPlaceId === "1" ? decodeToken.branchId : locationData.branchId;
        let branchIdList = [branchId];
        let data = {
            selectedDate: selectedBsDates,
            reportId: selectedBsReport,
            branchIdList: branchIdList
        }
        setBsReportLoading(true);
        // generateStatementReportBranchSummary(data).then((res) => {
        bsNotesReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setBsReportLoading(false);
        })
    };

    const generateDepositBalanceChesk = () => {
        let data = {
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            isExcel: isExcelBalanceCheckCertificate,
        };
        setDepositBalanceLoading(true);
        generatebalanceCheckDeposit(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDepositBalanceLoading(false);
        })
    };

    const generateLoanBalanceChesk = () => {
        let data = {
            branchId: loginPlaceId === "1" ? branchId : selectedBranch,
            isExcel: isExcelBalanceCheckCertificateLoan,
        };
        setLoanBalanceLoading(true);
        generatebalanceCheckLoan(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setLoanBalanceLoading(false);
        })
    };

    const handleDailyWork = () => {
        if (isPdfFormat) {
            generateDailyWorkReport();
        } else {
            generateDailyWork();
        }
    }


    const generateDailyWorkReport = () => {
        let branchId = (loginPlaceId === "1") ? decodeToken.branchId : selectedBranch;
        const data = {
            branchId: branchId,
            selectedDate: otherBankDate
        };
        setDailyReportLoading(true);
        dailyWorkDetailsReport(data).then((res) => {
            generateBlob(res.data)
        }).catch((err) => {
            errHandler(err)
        }).finally(() => {
            setDailyReportLoading(false);
        })
    };

    const generateDailyWork = () => {
        let branchId = (loginPlaceId === "1") ? decodeToken.branchId : selectedBranch;
        const data = {
            branchId: branchId,
            selectedDate: otherBankDate
        };
        setDailyReportLoading(true);
        getDailyWorkDetails(data)
            .then((res) => {
                const data = createDailyWorkData(res.data);
                let passData = {
                    tableData: data,
                    selectedDate: otherBankDate
                }
                navigation("daily-work", { state: passData })
            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDailyReportLoading(false);
            });

    };


    //dail transaction

    const generateDailyTransaction = () => {
        let branchId = (loginPlaceId === "1") ? decodeToken.branchId : selectedBranch;
        const data = {

            date: otherBankDate,
            userId: selectedUser,
            branchId: branchId,
            transactions: selectedTransaction
        };
        setDailyTransactionLoading(true);
        getAllDailyTransactions(data)
            .then(async (res) => {
                const dataD = createDailyTransaction(res.data);
                setDailyTransactionData(dataD)

                let passData = {
                    tableData: dataD,
                    selectedDate: otherBankDate
                }
                navigation("daily-transactions", { state: dataD })
            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDailyTransactionLoading(false);
            });

    };
    // distributionList
    const generateDistributionList = () => {
        let branchId = (loginPlaceId === "1") ? decodeToken.branchId : selectedBranch;
        const data = {

            distributionId: selectedDistributionId,
            branchId: branchId,
            isExcel: isExcelDistributionList,

        };
        setDistributionListLoading(true);
        getAllDistributionList(data)
            .then((res) => {  // Fixed the syntax error here
                console.log(res)
                generateBlob(res.data);
            })
            .catch((err) => {
                errHandler(err);
            })
            .finally(() => {
                setDistributionListLoading(false);
            });

    };
    // const generateLoanBalanceChesk = () => {
    //     let data = {
    //         branchId: loginPlaceId === "1" ? branchId : selectedBranch,
    //         isExcel: isExcelBalanceCheckCertificateLoan,
    //     };
    //     setLoanBalanceLoading(true);
    //     generatebalanceCheckLoan(data).then((res) => {
    //         generateBlob(res.data)
    //     }).catch((err) => {
    //         errHandler(err)
    //     }).finally(() => {
    //         setLoanBalanceLoading(false);
    //     })
    // };
    //daily transaction

    const generateCustomerDetailsReport = () => {
        const [startDate, endDate] = selectedDates || [];

        const data = {

            districtIdList: selectedDistricts != null ? [selectedDistricts] : [],
            branchIds: selectedBranches != null ? selectedBranches : [],
            wasamIdList: selectedWasams != null ? selectedWasams : [],
            cusNos: Array.from(new Set([...selectedCustomerNumbersByName, ...selectedCustomerNumbersByNumber])),
            activeStatus: selectedCustomerStatus,
            depositProductIds: selectedDepositProducts,
            loanProductIds: selectedLoanProducts,
            isExcel: isExcelCustomerReport,
        };

        setCustomerDetailsLoading(true);

        if (isExcelCustomerReport) {
            customerDetailsReportExcel(data)
                .then((res) => {
                    generateCustomerDetailsExcel(res);
                })
                .catch((err) => {
                    errHandler(err);
                })
                .finally(() => {
                    setCustomerDetailsLoading(false);
                })
        } else {
            customerDetailsReportPdf(data)
                .then((res) => {
                    generateBlob(res.data);
                })
                .catch((err) => {
                    errHandler(err);
                })
                .finally(() => {
                    setCustomerDetailsLoading(false);
                })
        }



    };



    const isInitialMount = useRef(true);

    const fetchUserDataByBranchId = async (id) => {

        getAllUsersByBranch(id)
            .then((res) => {
                const data = (res.data);

                setUserData(data);

            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDailyReportLoading(false);
            });
    };
    const fetchUserData = async () => {


        getAllUsersByBranch(branchId)
            .then((res) => {
                const data = (res.data);

                setUserData(data);

            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDailyReportLoading(false);
            });
    };

    const fetchDitributionNamesByBranchId = async (id) => {

        getAllDistributionNameByBranch(id)
            .then((res) => {
                const data = createDistributionData(res.data);

                setDistributionData(data);

            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDistributionListLoading(false);
            });
    };
    // common distribution
    const fetchDitributionNames = async () => {
        console.log(branchId)
        getAllDistributionNameByBranch(branchId)
            .then((res) => {
                const data = createDistributionData(res.data);

                setDistributionData(data);

            })
            .catch((err) => {
                errHandler(err);
            }).finally(() => {
                setDistributionListLoading(false);
            });
    };


    const handleDistrictChange = (value) => {
        setSelectedDistrictBalanceCheck(value);

        // Set the branch selection to the first branch of the selected district
        const selectedDistrictData = districtData.find((district) => district.districtId === parseInt(value));
        if (selectedDistrictData) {
            setSelectedBranch(selectedDistrictData.branchDtoList[0].id);
        }
    };

    const getAllDistrictDivisionalBranch = () => {
        getDistrictDivisionalBranchDetails().then((res) => {
            setDistrictDivisionalBranchData(res.data);
        }).catch((err) => {
            errHandler(err);
        })
    };


    useEffect(() => {
        if (!isInitialMount.current) {
            if (loginPlaceId !== "1") {
                getAllBranchesbyDistrict();
                setSelectedBranch("");
            }
        } else {
            isInitialMount.current = false;
        }
    }, [selectedDistrictBalanceCheck]);


    useEffect(() => {
        if (selectedDistricts) {
            getBranchList(selectedDistricts);
            setSelectedBranches(null);
        }
    }, [selectedDistricts]);

    useEffect(() => {
        if (selectedBranches) {
            getWasamList(selectedBranches);
            setSelectedWasams(null);
        }
    }, [selectedBranches]);

    useEffect(() => {
        getAllDistrictDivisionalBranch();
        getAllDeposits();
        getAllLoans();
        getAllDistrictl();
        getAllDistricts();
        getAllReports();
        getAllBsReports();

        if (loginPlaceId === "4") {
            getAllBranchesbyDistrict();
            setSelectedDistricts(districtId);

        } else if (loginPlaceId === "2") {
            getAllBranchesByDivAId();
            getBranchesByDivAId();
            setSelectedDivisionalArea(divAId)

        }
        else if (loginPlaceId === "1") {
            fetchUserData();
            fetchDitributionNames();
            setSelectedBranches([branchId]);

        }


    }, [])
    return (
        <>
            <div>
                <h3>General</h3>
            </div>
            <Collapse accordion>

                <PermissionPanel
                    permission="districtWiseLoanAndDepositCount"
                    placeIds={["3"]}
                    header="District Wise Savings and Loans Count Report"
                    key="districtWiseLoanAndDepositCount"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeSavingsAndLoans} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateDistrictWiseLoanAndSavingCountReports} disabled={districtDepositLoading}>
                                                {districtDepositLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>




                <PermissionPanel
                    permission="investmentSummaryReport"
                    placeIds={["3"]}
                    header="Investment Summary Report"
                    key="investmentSummaryReport"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="District Selection">
                                                <Radio.Group onChange={handleDistrictRadioChange} value={districtRadio}>
                                                    <Radio value={1}>All District</Radio>
                                                    <Radio value={2}>Choose District</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {loginPlaceId === "3" && districtRadio === 2 && (

                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <Select value={selectedDistrictBalanceCheck} onChange={handleDistrictChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select District --</Option>
                                                    {districtData.map((district) => (
                                                        <Option key={district.districtId} value={district.districtId}>
                                                            {district.districtName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        {loginPlaceId === "3" && (selectedDistrictBalanceCheck || selectedDivisionalArea) && (
                                            <Form.Item label="Branch Selection">
                                                <Radio.Group onChange={onRadioChange} value={branchRadio}>
                                                    <Radio value={0}>All Branches</Radio>
                                                    <Radio value={1}>Choose Branch</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        )}
                                    </Col>
                                    {loginPlaceId === "3" && branchRadio === 1 && selectedDistrictBalanceCheck && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    {districtData.find((district) => district.districtId === parseInt(selectedDistrictBalanceCheck)).branchDtoList.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Date Range">
                                            <RangePicker onChange={handleDateChangeInvestment} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select a time period">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Select a period"
                                                optionLabelProp="label"
                                                options={investmentPeriodOptions}
                                                onChange={handleTimePeriodChangeBranch}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeInvestmentSummary} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateOtherBankReport} disabled={!selectedDates || investDistrictLoading || !innvestTimePeriodBranch}>
                                                {investDistrictLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="districtWiseLoanAndDepositCount"
                    placeIds={["3"]}
                    header="Samurthi Bank Gender Wise Customer Details"
                    key="districtWiseLoanAndDepositCount1"
                    className={`collapse-panel ${loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24}>
                                        <Form.Item label="Select District">
                                            <Select value={selectedDistrictForGenderWiseDetails} onChange={handleDistrictWiseGenderDetails} style={{ width: '100%' }}>
                                                <Option value="">-- Select District --</Option>
                                                <Option key="0" value="ALL">ALL DISTRICTS</Option>
                                                {districtData.map((district) => (
                                                    <Option key={district.districtId} value={district.districtName}>
                                                        {district.districtName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchChangeGenderWiseCustomer} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateSamurthiBankDetails} disabled={samurdhiBankDetailsLoading}>
                                                {samurdhiBankDetailsLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>
                <PermissionPanel
                    permission="socialBenefitsAccountReport"
                    placeIds={["1", "4", "2", "3"]}
                    header="Prosperity Subsidy and Social Benefits to Accounts Reports"
                    key="prosperitySubsidyReport"
                    className="collapse-panel">
                    <ProsperityReport loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={districtId} branch={decodeToken.branchId} />
                </PermissionPanel>

                <PermissionPanel
                    permission="commonDistributionExcel"
                    placeIds={["2", "3", "4"]}
                    header="Social Benefit Account Report(Common Distribution)"
                    key="commonDistributionExcel"
                    className={`collapse-panel ${loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <CommonDistribution
                        loginPlaceId={loginPlaceId}
                        districtName={districtName}
                        districtDivisionalBranchData={districtDivisionalBranchData}
                        divisionalId={divAId}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="investmentSummaryReport"
                    placeIds={["1", "4", "2"]}
                    header="Investment Report"
                    key="investmentSummaryReport"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "4" && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}

                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}


                                    <Col span={24}>
                                        <Form.Item label="Select Date Range">
                                            <RangePicker onChange={handleDateChangeInvestment} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select a time period">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder="Select a period"
                                                optionLabelProp="label"
                                                options={investmentPeriodOptions}
                                                onChange={handleTimePeriodChangeBranch}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateOtherReportBranchWise} disabled={!selectedDates || investmentLoading}>
                                                {investDistrictLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="investmentSummaryReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Branch Wise Investment Summary"
                    key="branchWiseInvestmentSummary"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" || loginPlaceId === "1" ? '' : 'hidden'}`}
                >
                    <BranchWiseInvestmentSummary
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divAId}
                        branchId={branchId}
                        loading={branchWiseInvestmentLoading}
                        setLoading={setBranchWiseInvestmentLoading}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="investmentReviewReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Investment Review Report"
                    key="investmentReviewReport"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <InvestmentReviewReport
                        loginPlaceId={loginPlaceId}
                        districtData={districtDivisionalBranchData}
                        districtName={districtName}
                        divisionalId={divAId}
                        branchId={branchId}
                        loading={investReviewLoading}
                        setLoading={setInvestReviewLoading}
                    />
                </PermissionPanel>

                <PermissionPanel
                    permission="investmentTrailBalance"
                    placeIds={["1", "4", "2","3"]}
                    header="Investment Trail Balance"
                    key="investmentTrailBalance"
                    className={`collapse-panel `}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} divisionalId={divAId} onChange={setLocationData} />

                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setInvestDistrictDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateInvestmentTrailBalanceBranch} disabled={investReviewLoading || !investDistrictDate}>
                                                {investReviewLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="incomeReportSummaryPDF"
                    placeIds={["1", "4", "2","3"]}
                    header="Income Report Summary"
                    key="incomeReportSummaryPDF"
                    className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divAId} onChange={setLocationData} />
                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24}>
                                        <Form.Item label="Select Report Type">
                                            <Select value={selectedReport} onChange={handleReportChange} style={{ width: '100%' }}>
                                                {reportData.map(data => (
                                                    <Option key={data.rptId} value={data.rptId}>
                                                        {data.reportName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>

                                    <Col span={24}>
                                        <Form.Item label="Select Date Range">
                                            <RangePicker onChange={handleDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item>
                                            <Form.Item name={"pnlFormat"} valuePropName={"checked"} noStyle>
                                                <Checkbox onChange={handleCheckboxChange}>PNL Nodes</Checkbox>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={onSubmit} disabled={!selectedDates || incomeReportLoading}>
                                                {incomeReportLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>

                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="statementReportSummaryPDF"
                    placeIds={["1", "2","3", "4"]}
                    header="Statement Report Summary" key="statementReportSummaryPDF"
                     className={`collapse-panel`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <BranchLocationSelector loginPlaceId={loginPlaceId} districtData={districtDivisionalBranchData} districtName={districtName} divisionalId={divAId} onChange={setLocationData} />

                                <Row gutter={[16, 16]} justify="space-around">
                                    <Col span={24}>
                                        <Form.Item label="Select Report Type">
                                            <Select value={selectedBsReport} onChange={handleBsReportChange} style={{ width: '100%' }}>
                                                {bsReportData.map(data => (
                                                    <Option key={data.rptId} value={data.rptId}>
                                                        {data.reportName}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={handleBsDateChange} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item>
                                            <Form.Item name={"pnlFormat"} valuePropName={"checked"} noStyle>
                                                <Checkbox onChange={handleBsCheckboxChange}>BS Nodes</Checkbox>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateBsReport} disabled={!selectedBsDates || bsReportLoading}>
                                                {bsReportLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="accountBalanceCheckCertificate"
                    placeIds={["1", "2", "3", "4"]}
                    header="Balance Check Certificate Deposits"
                    key="accountBalanceCheckCertificate"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDistrictBalanceCheck}
                                                    onChange={handleDistrictSelectForBalanceCheck}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {(loginPlaceId === "4" || loginPlaceId === "3") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}--{branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    {(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2") && (
                                        <Col span={24}>
                                            <Form.Item label="Generate Excel Sheet">
                                                <Switch defaultChecked={false} onChange={onSwitchBalanceCheckCertificate} />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateDepositBalanceChesk} disabled={(loginPlaceId === "3" ? !selectedDistrict && selectedBranch === "" : loginPlaceId === "2" ? selectedBranch === "" : loginPlaceId === "4" ? selectedBranch === "" : false)}>
                                                {depositBalanceLoding ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="loanBalanceCheckCertificate"
                    placeIds={["1", "2", "3", "4"]}
                    header="Balance Check Certificate Loans"
                    key="loanBalanceCheckCertificate"
                    className={`collapse-panel ${loginPlaceId === "1" || loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "3" && (
                                        <Col span={24}>
                                            <Form.Item label="Select District">
                                                <AutoComplete
                                                    value={selectedDistrictBalanceCheck}
                                                    onChange={handleDistrictSelectForBalanceCheck}
                                                    dataSource={filteredData.map((district) => district.districtName)}
                                                    placeholder="Select a district"
                                                    style={{ width: '100%' }}
                                                />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {(loginPlaceId === "4" || loginPlaceId === "3") && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }} dropdownStyle={{ maxHeight: 200, overflow: 'auto' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}--{branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    {loginPlaceId === "2" && (
                                        <Col span={24}>
                                            {divAreaData.length > 0 && selectedDivisionalArea && (
                                                <Form.Item label="Select Branch">
                                                    <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                        {divAreaData
                                                            .find((divArea) => divArea.divAId === parseInt(selectedDivisionalArea))
                                                            .branchDtoList.map((branch) => (
                                                                <Option key={branch.id} value={branch.id}>
                                                                    {branch.branchName}
                                                                </Option>
                                                            ))}
                                                    </Select>
                                                </Form.Item>
                                            )}
                                        </Col>
                                    )}
                                    {(loginPlaceId === "4" || loginPlaceId === "3" || loginPlaceId === "2") && (
                                        <Col span={24}>
                                            <Form.Item label="Generate Excel Sheet">
                                                <Switch defaultChecked={false} onChange={onSwitchBalanceCheckCertificateLoan} />
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateLoanBalanceChesk} disabled={(loginPlaceId === "3" ? !selectedDistrict && selectedBranch === "" : loginPlaceId === "2" ? selectedBranch === "" : loginPlaceId === "4" ? selectedBranch === "" : false)}>
                                                {loanBalanceLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="dailyWorkDetails"
                    placeIds={["1"]}
                    header="Daily Work Report"
                    key="dailyWorkDetails"
                    className={`collapse-panel ${loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">

                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "4" && (
                                        <Col span={24}>
                                            <Form.Item label="Select Branch">
                                                <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                    <Option value="">-- Select --</Option>
                                                    {branchData.length > 0 &&
                                                        branchData.map((branch) => (
                                                            <Option key={branch.id} value={branch.id}>
                                                                {branch.branchName}--{branch.branchName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    )}
                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setOtherBankDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item>
                                            <Form.Item name={"pdfFormat"} valuePropName={"checked"} noStyle>
                                                <Checkbox onChange={handleDailyWorkCheckboxChange}>pdf format</Checkbox>
                                            </Form.Item>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={handleDailyWork} disabled={!otherBankDate || dailyReportLoading}>
                                                {dailyReportLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>

                <PermissionPanel
                    permission="dailyTransaction"
                    placeIds={["1"]}
                    header="Daily Transaction"
                    key="dailyTransaction"
                    className={`collapse-panel ${loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "4" && (<Col span={24}>
                                        <Form.Item label="Select Branch">
                                            <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select --</Option>
                                                {branchData.length > 0 &&
                                                    branchData.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}--{branch.branchName}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>)}

                                    <Col span={24}>
                                        <Form.Item label="Select Date">
                                            <DatePicker onChange={(date) => setOtherBankDate(date)} disabledDate={disabledDate} style={{ width: '100%' }} />
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select User">
                                            <Select value={selectedUser} onChange={handleUserChange} style={{ width: '100%' }}>
                                                <Option value={0}>All</Option>
                                                {userData.map((user) => (
                                                    <Option key={user.id} value={user.id}>
                                                        {user.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Select Transactions">
                                            <Select
                                                mode="multiple"
                                                value={selectedTransaction}
                                                onChange={handleTransactions}
                                                style={{ width: '100%' }}
                                                maxTagCount='responsive'
                                                maxTagTextLength={10}
                                                placeholder="Select transactions"
                                            >
                                                <Option value={1}>Cash-Deposit Accounts</Option>
                                                <Option value={2}>Cash-Ledger Account</Option>
                                                <Option value={3}>Non Cash - Deposit Accounts</Option>
                                                <Option value={4}>Non Cash - Ledger Accounts</Option>
                                                <Option value={5}>Non Cash -Withdraw Accounts</Option>
                                            </Select>
                                        </Form.Item>
                                    </Col>
                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateDailyTransaction} disabled={!otherBankDate || dailyTransactionLoading}>
                                                {dailyTransactionLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>


                <PermissionPanel
                    permission="commonDistribution"
                    placeIds={["1"]}
                    header="Common Distribution List" key="commonDistribution"
                    className={`collapse-panel ${loginPlaceId === "1" ? '' : 'hidden'}`}>
                    <div className="panel-container">
                        <Card hoverable className="inner-card">
                            <Form layout="vertical">
                                <Row gutter={[16, 16]} justify="space-around">
                                    {loginPlaceId === "4" && (<Col span={24}>
                                        <Form.Item label="Select Branch">
                                            <Select value={selectedBranch} onChange={handleBranchChange} style={{ width: '100%' }}>
                                                <Option value="">-- Select --</Option>
                                                {branchData.length > 0 &&
                                                    branchData.map((branch) => (
                                                        <Option key={branch.id} value={branch.id}>
                                                            {branch.branchName}--{branch.branchName}
                                                        </Option>
                                                    ))}
                                            </Select>
                                        </Form.Item>
                                    </Col>)}

                                    <Col span={24}>
                                        {(

                                            <Form.Item label="Select Distribution Name">
                                                <Select value={selectedDistributionId} onChange={handleDistributionNameChange} style={{ width: '100%' }}>

                                                    {distributionData

                                                        .map((ditributionName) => (
                                                            <Option key={ditributionName.id} value={ditributionName.id}>
                                                                {ditributionName.listName}
                                                            </Option>
                                                        ))}
                                                </Select>
                                            </Form.Item>
                                        )}
                                    </Col>
                                    <Col span={24}>
                                        <Form.Item label="Generate Excel Sheet">
                                            <Switch defaultChecked={false} onChange={onSwitchDistributionList} />
                                        </Form.Item>
                                    </Col>

                                    <Col span={24} style={{ textAlign: 'right' }}>
                                        <Form.Item className="generate-btn-outline">
                                            <Button className="generate-btn" onClick={generateDistributionList}>
                                                {distributionListLoading ? <Spin /> : 'Generate Report'}
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </Form>
                        </Card>
                    </div>
                </PermissionPanel>


                <PermissionPanel
                    permission="statementReportSummaryExcel"
                    placeIds={["3", "4"]}
                    header="District Bs Nodes"
                    key="statementReportSummaryExcel"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <DistrictBsNodesReport loginPlaceId={loginPlaceId} districtData={districtData} districtName={districtName} />
                </PermissionPanel>
                <PermissionPanel
                    permission="incomeReportSummaryExcel"
                    placeIds={["3", "4"]}
                    header="District PNL Nodes"
                    key="incomeReportSummaryExcel"
                    className={`collapse-panel ${loginPlaceId === "4" || loginPlaceId === "3" ? '' : 'hidden'}`}>
                    <DistrictPnlNodesReport loginPlaceId={loginPlaceId} districtData={districtData} districtName={districtName} />
                </PermissionPanel>

                <PermissionPanel
                    permission="customerDetailsReport"
                    placeIds={["1", "2", "3", "4"]}
                    header="Customer Details Report"
                    key="customerDetailsReport" className={`collapse-panel`}>
                    <div className="panel-container">
                        <CustomerDetailsReport
                            loginPlaceId={loginPlaceId}
                            districts={districts}
                            branches={branches}
                            wasams={wasams}
                            depositsProducts={depositsProducts}
                            loanProducts={loanProducts}
                            branchesForDivArea={branchesForDivArea}
                            selectedDistricts={selectedDistricts}
                            handleDistrictsChange={handleDistrictsChange}
                            setSelectedBranches={setSelectedBranches}
                            selectedWasams={selectedWasams}
                            handleWasamChange={handleWasamChange}
                            selectedDepositProducts={selectedDepositProducts}
                            handleDepositProductChange={handleDepositProductChange}
                            selectedLoanProducts={selectedLoanProducts}
                            handleLoanProductChange={handleLoanProductChange}
                            selectedCustomerStatus={selectedCustomerStatus}
                            setSelectedCustomerStatus={setSelectedCustomerStatus}
                            selectedCustomerNumbersByNumber={selectedCustomerNumbersByNumber}
                            setSelectedCustomerNumbersByNumber={setSelectedCustomerNumbersByNumber}
                            handleCustomerSearch={handleCustomerSearch}
                            handleCustomerNameChange={handleCustomerNameChange}
                            selectedCustomerNumbersByName={selectedCustomerNumbersByName}
                            customerSearchResults={customerSearchResults}
                            isExcelCustomerReport={isExcelCustomerReport}
                            setIsExcelCustomerReport={setIsExcelCustomerReport}
                            selectedDates={selectedDates}
                            generateCustomerDetailsReport={generateCustomerDetailsReport}
                            customerDetailsLoading={customerDetailsLoading}
                        />
                    </div>
                </PermissionPanel>



            </Collapse >
            <CustomFooter />
        </>
    )
};
export default General;